import {IntlMessageFormat} from 'intl-messageformat'

// [CG] Bounded compiled-pattern cache; parameter values are never cached.
const compiled_messages = new Map()
const fallback_locale = 'en-US'
const cache_limit = 200

export function message_locale(locale) {
    try {
        return Intl.getCanonicalLocales(String(locale).replace(/_/g, '-'))[0]
            || fallback_locale
    } catch {
        return fallback_locale
    }
}

export function format_message(pattern, parameters = {}, options = {}) {
    const valid_parameters = parameters && !Array.isArray(parameters)
        && typeof parameters === 'object'
        && Object.values(parameters).every(value => typeof value === 'string'
            || (typeof value === 'number' && Number.isFinite(value)))
    for (const [candidate, locale] of [
        [pattern, options.locale || fallback_locale],
        [options.fallback, options.fallback_locale || fallback_locale]
    ]) {
        if (typeof candidate !== 'string' || candidate === '') continue
        // [CG] Plain fallback copy remains available after invalid parameters.
        if (!valid_parameters) {
            if (!candidate.includes('{') && !candidate.includes('}')) return candidate
            continue
        }
        try {
            const resolved_locale = message_locale(locale)
            const cache_key = JSON.stringify([resolved_locale, candidate])
            let formatter = compiled_messages.get(cache_key)
            if (!formatter) {
                formatter = new IntlMessageFormat(candidate, resolved_locale,
                    undefined, {ignoreTag: true})
                if (compiled_messages.size >= cache_limit) {
                    compiled_messages.delete(compiled_messages.keys().next().value)
                }
                compiled_messages.set(cache_key, formatter)
            }
            return String(formatter.format(parameters))
        } catch {
            // [CG] Try the complete fallback, never a partially formatted sentence.
        }
    }
    return options.key || 'This message is unavailable.'
}

export function translate_message(key, parameters, messages, options = {}) {
    const entry = messages?.[key]
    return format_message(typeof entry === 'string' ? entry : entry?.pattern,
        parameters, {...options, key,
            locale: entry?.locale || options.locale || fallback_locale})
}
